import { Controller } from "@hotwired/stimulus"

// Controller for custom date range selection
// Used alongside the generic dropdown controller
export default class extends Controller {
  static targets = ["startDate", "endDate"]

  applyCustomRange(event) {
    event.preventDefault()

    const startDate = this.startDateTarget.value
    const endDate = this.endDateTarget.value

    if (!startDate || !endDate) {
      alert("Please select both start and end dates")
      return
    }

    if (new Date(startDate) > new Date(endDate)) {
      alert("Start date must be before end date")
      return
    }

    // Navigate with custom date parameters
    const url = new URL(window.location.href)
    url.searchParams.set("filter", "custom")
    url.searchParams.set("start_date", startDate)
    url.searchParams.set("end_date", endDate)
    url.searchParams.delete("page") // Reset pagination

    window.location.href = url.toString()
  }
}
